(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-personalized-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var DEFAULT_MS = 1000;
  var selector = '[data-personalized-collection]';

  function getLoadingMs(root) {
    var raw = root.getAttribute('data-loading-ms');
    if (raw == null || raw === '') {
      return DEFAULT_MS;
    }
    var n = parseInt(raw, 10);
    return isNaN(n) || n < 0 ? DEFAULT_MS : n;
  }

  function removeSkeleton(root) {
    var skel = root.querySelector('.js-personalized-skeleton');
    if (skel) {
      skel.remove();
    }
    root.setAttribute('aria-busy', 'false');
  }

  function init() {
    var roots = document.querySelectorAll(selector);
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    for (var i = 0; i < roots.length; i += 1) {
      (function (root) {
        if (!root.querySelector('.js-personalized-skeleton')) {
          return;
        }
        var ms = getLoadingMs(root);
        if (reduce || ms === 0) {
          removeSkeleton(root);
        } else {
          root.setAttribute('aria-busy', 'true');
          window.setTimeout(function () {
            removeSkeleton(root);
          }, ms);
        }
      })(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
